import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/loading
 * @param {String} type - type for sucess/error/loading
 */

export const moduleListSuccess = (
  payload = {},
  type = types.MODULE_LIST_SUCCESS
) => {
  return {
    type,
    payload
  };
};

export const moduleListLoading = (
  payload = {},
  type = types.LOADING_MODULE_LIST
) => {
  return {
    type,
    payload
  };
};
